/* tslint:disable */
/* eslint-disable */
/**
 * Live CSV Data Import Plugin
 * Plugin to handle CSV imported CSV files
 *
 * The version of the OpenAPI document: 1.23.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Message
 */
export interface Message {
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    result?: string;
    /**
     * 
     * @type {number}
     * @memberof Message
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    statusText?: string;
}

/**
 * Check if a given object implements the Message interface.
 */
export function instanceOfMessage(value: object): value is Message {
    return true;
}

export function MessageFromJSON(json: any): Message {
    return MessageFromJSONTyped(json, false);
}

export function MessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): Message {
    if (json == null) {
        return json;
    }
    return {
        
        'result': json['result'] == null ? undefined : json['result'],
        'status': json['status'] == null ? undefined : json['status'],
        'statusText': json['statusText'] == null ? undefined : json['statusText'],
    };
}

export function MessageToJSON(json: any): Message {
    return MessageToJSONTyped(json, false);
}

export function MessageToJSONTyped(value?: Message | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'result': value['result'],
        'status': value['status'],
        'statusText': value['statusText'],
    };
}

